<template>
  <div>
    <div class="auto_1280">
      <div class="vlovedonation">
        <div class="part1 clearfix">
          <div class="left">
            <div class="title">{{content.title}}</div>
            <div class="txt">{{content.intro}}</div>
            <div class="qrcode">
              <img :src="content.content" alt="">
              <pre v-if="lan === 0">{{text}}</pre>
              <pre v-else-if="lan === 1">{{enText}}</pre>
            </div>
          </div>
          <div class="right">
            <img :src="content.coverImg" alt="">
            <!-- <svg width:="0" height="0">
              <defs>
                <clipPath id="svgPath" clipPathUnits="objectBoundingBox" transform="scale(0.0017452006980803, 0.0018315018315018)">
                  <path fill="rgb(228, 0, 127)" opacity="0.149" fill-rule="evenodd" stroke="#000000" stroke-width="1.5794" stroke-miterlimit="10" d="M27.967,327.074 C27.967,327.074 53.947,379.133 108.689,412.472 C163.431,445.810 195.256,453.602 267.059,465.557 C338.862,477.512 415.280,488.077 464.637,461.710 C513.994,435.343 538.848,388.836 536.134,313.996 C533.420,239.155 527.082,188.996 502.307,132.430 C477.533,75.864 439.451,37.275 416.203,19.336 C392.956,1.396 353.825,-9.297 270.134,15.489 C186.444,40.275 139.582,55.866 95.620,78.576 C51.658,101.285 10.960,118.412 3.366,180.129 C-4.229,241.847 2.862,280.121 27.967,327.074 Z" />
                </clipPath>
              </defs>
            </svg> -->
          </div>
        </div>
      </div>
    </div>
    <div class="vlovedonation part2">
      <div class="auto_1280">
        <div class="tit" v-if="content.tag !== 'true'">{{content.tag}}</div>
        <ul class="ul clearfix">
          <li v-for="( item, index ) in donateList" :key="index" @click="goDetail(item.id)">
            <div class="box">
              <div class="pic bg_cover" :style="'background-image: url(' + item.coverImg + ')'"></div>
              <div class="content">
                <div class="inner">
                  <span class="icon" v-if="item.isUpload === 1"></span>
                </div>
              </div>
            </div>
            <div>
              <div class="title1 dot">{{item.title}}</div>
              <div class="intro dot">{{item.intro}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VloveDonation',
  data () {
    return {
      meunList: [],
      pageList: [],
      articleTypeId: 8,
      pageIndex: 1,
      pageSize: 6,
      total: 0,
      maxPageIndex: 1,
      lan: this.$store.state.isEn,
      content: {},
      donateList: [],
      text: '手机扫二维码\n捐赠爱心',
      enText: 'Scanning QR code\nDonate Your Love'
    }
  },
  watch: {
    pageIndex (val, oldval) {
      if (val !== oldval) {
        this.init()
      }
    },
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      if (this.pageIndex !== 1) {
        this.pageIndex = 1
      } else {
        this.init()
      }
    }
  },
  mounted () {
    localStorage.removeItem('path')
    localStorage.removeItem('columnId')
    const self = this
    self.initId()
    self.init()
  },
  activated () {
    this.initId()
  },
  methods: {
    initId () {
      // const self = this
      // let menuList
      // try {
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         this.articleTypeId = inner.id
      //         this.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      this.$store.commit('changeId', this.articleTypeId)
    },
    init () {
      const self = this
      this.content = ''
      this.donateList = []
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: self.articleTypeId, current: 1, pageSize: 1, bLanguage: this.lan, isDelete: 0, state: 1, tag: 'true' }, r => {
        if (r) {
          self.content = r.data[0]
        }
      })
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: self.articleTypeId, current: 1, pageSize: 100, bLanguage: this.lan, isDelete: 0, state: 1 }, r => {
        if (r.data) {
          r.data.forEach((item) => {
            if (item.tag === '') {
              self.donateList.push(item)
            }
          })
        }
      })
    },
    goDetail (id) {
      const index = this.$route.path.lastIndexOf('/')
      localStorage.setItem('path', this.$route.path.substring(index + 1, this.$route.path.length))
      localStorage.setItem('columnId', this.$route.query.columnId)
      this.$router.push({
        path: '/welfare/detail',
        query: {
          columnId: this.$route.query.columnId,
          articleTypeId: this.articleTypeId,
          id
        }
      })
    }
  }
}
</script>
<style scoped>
.vlovedonation{margin: 4% 0 0; position: relative;}

.vlovedonation .part1{padding: 0 0 3%;}
.vlovedonation .left,
.vlovedonation .right{width: 50%; float: left;}
.vlovedonation .left{padding-right: 15%; box-sizing: border-box;}
.vlovedonation .left .title{font-size: 40px; color: #e4007f;}
.vlovedonation .txt{font-size: 16px; line-height: 2; padding: 12% 0 15%;}
.vlovedonation .right{
  /* background: url(../../assets/vlovebg.png)no-repeat center;  */
  text-align: center; background-size: contain; position: relative;}
.vlovedonation .right img{width: 80%; clip-path: url(#svgPath); -webkit-clip-path: url(#svgPath);}
.vlovedonation .qrcode pre{display: inline-block; vertical-align: middle; padding-left: 5%; line-height: 1.8; font-size: 14px; color: #666; font-weight: lighter;}

.vlovedonation.part2{background-color: #f8f8f8; overflow: hidden; padding-top: 4%;}
.vlovedonation .box{position: relative;}
.vlovedonation ul{margin: 0 -4%; padding: 0 0 5%;}
.vlovedonation li{width: 38%; margin: 2% 6%; float: left; position: relative; cursor: pointer;}
.vlovedonation .pic{width: 100%; padding-top: 65%; border-radius: 5px;}
.vlovedonation .content{position: absolute; width: 100%; height: 100%; left: 0%; top: 0; background-color: rgba(0, 0, 0, .2); border-radius: 5px; color: #fff; text-align: center;}
.vlovedonation .inner{position: absolute; width: 100%; left: 0; top: 50%; transform: translateY(-50%);}
.vlovedonation .title1{font-size: 20px; line-height: 1.8; transition: all .3s ease-in-out; padding-top: 1%;}
.vlovedonation .intro{letter-spacing: 2px; font-size: 16px; transition: all .3s ease-in-out; min-height: 21px;}
.vlovedonation .center{margin: 0 auto; width: 26%; min-height: 200px;}
.vlovedonation .center img{border-radius: 5px;}
.vlovedonation .icon{background: url(../../assets/play-icon.png)no-repeat center; width: 56px; height: 36px; display: inline-block; opacity: 0; transition: all .3s;}
.vlovedonation li:hover .icon{opacity: 1;}
.vlovedonation li:hover .title1,
.vlovedonation li:hover .intro{color: #e4007f;}
.vlovedonation .tit{font-size: 30px; padding: 2% 0 1% 2%;}
@media(max-width: 960px){
  .vlovedonation .left .title{font-size: 36px;}
  .vlovedonation .left{padding-right: 10%;}
}
@media(max-width: 640px){
  .vlovedonation .center{width: 100%; margin: 0; float: left;}
  .vlovedonation li{width: 100%; position: relative; margin: 2% 0 5% 0;}
  .vlovedonation ul{width: 100%; position: relative; margin: auto;}

  .vlovedonation .left,
  .vlovedonation .right{width: 100%; float: none;}
  .vlovedonation .right img{width: 100%;}
  .vlovedonation .right{padding-top: 5%;}
  .vlovedonation .left{padding-right: 0;}
  .vlovedonation .txt{padding: 3% 0;}

  .vlovedonation .qrcode img{max-width: 110px;}
  .vlovedonation .tit{padding-left: 0;}
  .vlovedonation .left .title{font-size: 30px;}

  .vlovedonation .icon{opacity: 1;}
}
@media(max-width: 480px){
  .vlovedonation .title{font-size: 16px;}
  .vlovedonation .intro{font-size: 13px; letter-spacing: 1px;}
}
</style>
